class SUAdminUserCtrl {

    constructor(CONTENT_TYPE, $apiService, $uibModal, Notification, $userService, $rootScope, EVENTS) {

        this.users = [];
        this.clients = [];
        this.currentUser = null;

        this.CONTENT_TYPE = CONTENT_TYPE;
        this.$apiService = $apiService;
        this.$uibModal = $uibModal;
        this.Notification = Notification;
        this.$userService = $userService;
        this.EVENTS = EVENTS;
        this.$rootScope = $rootScope;

        $apiService.list(CONTENT_TYPE.CLIENT, '')
            .then(response => {
                this.clients = response.data;
            });

        this.loadUsers();
    }

    loadUsers() {
        this.loading = true;
        this.$apiService.list(this.CONTENT_TYPE.USER, '')
            .then(response => {
                this.users = response.data;
                this.loading = false;
            });

    }

    addUser() {
        var modalInstance = this.$uibModal.open({
            animation: true,
            templateUrl: 'superuser/add-user.html',
            controller: 'AddUserCtrl',
            resolve: {
                rootFolder: () => '536ce1114e9c9835f6000001',
                clients: () => this.clients
            }
        });
        modalInstance.result.then((newItem) => {
            this.createUser(newItem);
        });
    }

    createUser(user) {
        user.securityRoles = user.securityRoles.join(',');
        this.$apiService.create(this.CONTENT_TYPE.USER, user)
            .then(response => {
                this.$rootScope.$emit(this.EVENTS.SHOW_NOTIFICATION, {'message': 'User created.'});
                this.loadUsers();
            }, error => console.error(error));
    }
    
    updateUser(user) {
        var modalInstance = this.$uibModal.open({
            animation: true,
            templateUrl: 'superuser/edit-user.html',
            controller: 'AddUserCtrl',
            resolve: {
                user: user,
                rootFolder: () => '536ce1114e9c9835f6000001',
                clients: () => this.clients
            }
        });
        modalInstance.result.then((newItem) => {
            this.updateUserRecord(newItem);
        }, () => {

        });
    }
    
    deleteUser(user) {
        var modalInstance = this.$uibModal.open({
            animation: true,
            templateUrl: 'delete-confirm.html',
            controller: 'DeleteConfirmationCtrl'
        });

        modalInstance.result.then(() => {
            this.$apiService.delete(this.CONTENT_TYPE.USER, user.id)
                .then((response) => {
                    this.$scope.$emit(this.EVENTS.SHOW_NOTIFICATION, {'message': 'User deleted.'});
                    this.loadUsers();
                }, (response) => {
                    console.error(response);
                    console.error(response);
                });
        },() => {
            // NOOP
        });
    }
    
    updateUserRecord(user) {
        user.securityRoles = user.securityRoles.join(',');
        this.$apiService.update(this.CONTENT_TYPE.USER, user)
            .then(response => {
                this.$scope.$emit(this.EVENTS.SHOW_NOTIFICATION, {'message': 'User updated.'});
                this.loadUsers();
            }, error => {
                console.error(error);
            });
    }
    
    changePassword(user) {
        var modalInstance = this.$uibModal.open({
            animation: true,
            templateUrl: 'admin/change-password.html',
            controller: 'AddItemCtrl'
        });

        modalInstance.result.then((newItem) => {
            this.$userService.changePassword(this.CONTENT_TYPE.USER, user.id, newItem.password)
                .then((response) => {
                    this.$scope.$emit(this.EVENTS.SHOW_NOTIFICATION, {'message': 'Password updated.'});
                    this.loadUsers();
                }, (response) => {
                    console.error(response);
                    console.error(response);
                });
        },() => {
            // NOOP
        });
    }

    updatePermissions(user) {
        var modalInstance = this.$uibModal.open({
            animation: true,
            templateUrl: 'admin/edit-permissions.html',
            controller: 'SetPermissionsCtrl',
            resolve: {
                user: user
            }
        });

        modalInstance.result.then((permissions) => {
            this.$userService.setPermissions(this.CONTENT_TYPE.USER, user.id, permissions)
                .then((response) => {
                    this.$scope.$emit(this.EVENTS.SHOW_NOTIFICATION, {'message': 'Permissions updated.'});
                    this.loadUsers();
                }, (response) => {
                    console.error(response);
                    console.error(response);
                });
        });
    }
    
    getClientName(id) {
        let client = this.clients.filter(c => c.id === id);
        return (client.length > 0 && client[0].hasOwnProperty('name'))
            ? client[0].name
            : 'NO CLIENT';
    }

    flushEntityCache() {
        this.$userService.flushEntityCache().then(response => this.$rootScope.$emit(this.EVENTS.SHOW_NOTIFICATION, {'message': 'Entity cache flushed.'}),
            response => console.error(response));
    }

}

angular.module('cpm')
    .controller('SUAdminUserCtrl', ['CONTENT_TYPE', 'ApiService', '$uibModal', 'Notification', 'UserService', '$rootScope', 'EVENTS', SUAdminUserCtrl]);
